import {connect, useDispatch} from 'react-redux';
import {
    branchDetailsViewSelect,
} from '../../redux/selector/additionalBranchSelector'
import Navigation from '../Navigation';
import TopNavigationBar from '../TopNavigationBar';
import { Button, Header } from '../../components/RegularComponents';
import ReviewForm from '../../components/ReviewForm/ReviewForm';
import { replaceUrlParams } from '../../app/utils';
import { ROUTE_PATH } from '../../app/constants';
import { push } from 'connected-react-router';

const BranchDetailsView = (props) => {
    const dispatch = useDispatch();
    const {currentBranchReviewData} = props;
    const { applicationType, applicationMode } = props.match.params

    const homePageUrl = replaceUrlParams(
        ROUTE_PATH.WELCOME, 
        applicationType, 
        applicationMode
    )

    return (
        <>
            <Navigation {...props} />
            <div className="container">
                <TopNavigationBar {...props} hideSaveAndExit />
                <div className="row bottomMarginLarge">
                    <div className="col-lg-8">
                        <Header 
                            id="current-branch-details-header"
                            header={"Branch Details"} />
                    </div>
                </div>
                <div className="row bottomMarginLarge">
                    <div className="col-lg-8 leftMarginMedium">
                        <ReviewForm fullSize data={currentBranchReviewData} />
                    </div>
                </div>
                <div className="row topMarginMedium">
                    <div className="col-lg-2">
                        <Button 
                            id="payment-confirmation-go-home-button"
                            buttonType="regular_primary"
                            text="Go to home page"
                            onClick={() => {dispatch(push(homePageUrl))}}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(branchDetailsViewSelect)(BranchDetailsView)